import { StepTask } from '@telespot/domain';

/**
 * Whether a protocol category is answered once per asset or once per sample.
 */
export enum ProtocolScope {
  Asset = 'asset',
  Sample = 'sample',
}

/**
 * A protocol category as analysis consumes it: display name already resolved,
 * and the owning step denormalized onto the category itself.
 */
export interface LabelCategory {
  id: string;
  name: string;
  stepId: string;
  stepTask: StepTask;
  scope: ProtocolScope;
  options: string[];
}

/**
 * A selectable label within a {@link LabelCategory}, carrying the presentation
 * concerns analysis needs: a resolved display name, a colour and a threshold.
 */
export interface LabelOption {
  id: string;
  name: string;
  threshold: number;
  color: string;
}
